











// Import CSS from bootstrap
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
// Import base-components:
import {Component, Vue} from "vue-property-decorator";
import Navigation from "./components/Navigation.vue";

@Component({
    components: {
        Navigation
    },
})
export default class App extends Vue {}
